import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../../environments/environment";

interface TranslationStatus {
    lastUpdated: string;
    version: string;
    languages: string[];
}

interface TranslationUpdateResult {
    success: boolean;
    message: string;
    details?: {
        outputDirectory: string;
        updatedFiles: Array<{
            language: string;
            path: string;
            lastModified: string;
        }>;
        timestamp: string;
    };
    error?: string;
}

@Injectable({
    providedIn: 'root'
})
export class TranslationsApiService {
    private readonly apiUrl = `${environment.api.host}/translations`;

    constructor(private http: HttpClient) {
    }

    /**
     * Déclenche une mise à jour manuelle des traductions
     * @returns Observable avec le résultat de la mise à jour
     */
    updateTranslations(): Observable<TranslationUpdateResult> {
        return this.http.post<TranslationUpdateResult>(`${this.apiUrl}/update`, {});
    }

    /**
     * Récupère le statut actuel des traductions
     * @returns Observable avec les informations de statut
     */
    getTranslationStatus(): Observable<TranslationStatus> {
        return this.http.get<TranslationStatus>(`${this.apiUrl}/status`);
    }

    /**
     * Récupère la liste des langues disponibles
     * @returns Observable avec la liste des langues
     */
    getAvailableLanguages(): Observable<{ languages: string[], count: number }> {
        return this.http.get<{ languages: string[], count: number }>(`${this.apiUrl}/languages`);
    }
}
